module.exports = { id: "standard", url: "/build/app/img/symbols.svg#standard", viewBox: "", toString: function() { return this.url; } };